import { Skeleton } from "@/shared/ui";

interface Props {
  variant?: "full" | "tableOnly";
}

export default function PurchasesPageSkeleton({ variant = "full" }: Props) {
  if (variant === "tableOnly") {
    return (
      <div className="flex flex-col">
        <div className="grid grid-cols-[1fr_1.5fr_0.5fr_1fr_1fr_1.5fr_1fr_0.5fr] gap-4 pb-3 border-b surface-base-stroke">
          {Array.from({ length: 8 }).map(function renderHeadSkeleton(_, i) {
            return <Skeleton key={i} height={20} />;
          })}
        </div>
        {Array.from({ length: 6 }).map(function renderRowSkeleton(_, rowIndex) {
          return (
            <div
              key={rowIndex}
              className="grid grid-cols-[1fr_1.5fr_0.5fr_1fr_1fr_1.5fr_1fr_0.5fr] gap-4 py-3 border-b surface-base-stroke">
              {Array.from({ length: 8 }).map(function renderCellSkeleton(_, colIndex) {
                return <Skeleton key={colIndex} height={20} />;
              })}
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="radius-3xl surface-base-fill p-7">
      <div className="flex items-center justify-between gap-2 mb-7">
        <div className="flex items-center gap-2">
          <Skeleton width={192} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton width={140} height={36} className="radius-xs" />
        </div>
      </div>

      <div className="flex flex-col">
        <div className="grid grid-cols-[1fr_1.5fr_0.5fr_1fr_1fr_1.5fr_1fr_0.5fr] gap-4 pb-3 border-b surface-base-stroke">
          {Array.from({ length: 8 }).map(function renderHeadSkeleton(_, i) {
            return <Skeleton key={i} height={20} />;
          })}
        </div>

        {Array.from({ length: 6 }).map(function renderRowSkeleton(_, rowIndex) {
          return (
            <div
              key={rowIndex}
              className="grid grid-cols-[1fr_1.5fr_0.5fr_1fr_1fr_1.5fr_1fr_0.5fr] gap-4 py-3 border-b surface-base-stroke">
              {Array.from({ length: 8 }).map(function renderCellSkeleton(_, colIndex) {
                return <Skeleton key={colIndex} height={20} />;
              })}
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between mt-4">
        <Skeleton width={200} height={20} />
        <div className="flex items-center gap-2">
          <Skeleton width={32} height={32} />
          <Skeleton width={32} height={32} />
          <Skeleton width={32} height={32} />
        </div>
      </div>
    </div>
  );
}
